import { Col, Row } from "reactstrap";
import { VERTICAL_ALIGNMENT } from "../../../../Data/UiKit/Grid";

export const DynamicVerticalAlignment = () => {
  return (
    <>
      {VERTICAL_ALIGNMENT.map((item, index) => (
        <Col lg="4" key={index}>
          <Row className={`grid-vertical ${item} m-1 g-2 bg-light`}>
            <Col xs="6"><span className="bg-white">one column</span></Col>
            <Col xs="6"><span className="bg-white">two column</span></Col>
          </Row>
        </Col>
      ))}
    </>
  );
};
